import { safe, state } from './config'
import { installCorrelation } from './correlation'
import { installErrors, recordError } from './errors'
import { installForms } from './forms'
import { installInteractions } from './interactions'
import { isActive, journeyId } from './journey'
import { registerRouterListeners } from './navigation'
import { installOverlays } from './overlays'
import { installPerformance } from './performance'
import { record } from './transport'

export { safe } from './config'
export { recordDialog } from './overlays'

let started = false

function installAll() {
  ;[installCorrelation, installInteractions, installForms, installOverlays, installErrors, installPerformance].forEach(
    (install) => safe(install)()
  )
}

// Only router.on listeners are registered here; nothing else is installed until a page enables capture.
export function startHelios() {
  if (started) {
    return
  }

  started = true
  safe(registerRouterListeners)(installAll)
}

export function heliosVueErrorHandler(error, instance, info) {
  safe(recordError)(error, 'vue', { info })

  if (!import.meta.env.VITE_BUGSNAG_API_KEY) {
    console.error(error)
  }
}

export const recordHelios = safe((type, fields = {}) => {
  record(type, fields)
})

export function currentHeliosIds() {
  try {
    return isActive()
      ? { journey_id: journeyId(), correlation_id: state.correlationId }
      : { journey_id: null, correlation_id: null }
  } catch {
    return { journey_id: null, correlation_id: null }
  }
}
